import { render, staticRenderFns } from "./ProductTitleWithPrice.vue?vue&type=template&id=ccd8d37c&"
import script from "./ProductTitleWithPrice.vue?vue&type=script&lang=js&"
export * from "./ProductTitleWithPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductTitleWithPrice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTitle: require('/opt/build/repo/storefront/components/molecules/Product/ProductTitle.vue').default,ProductPrice: require('/opt/build/repo/storefront/components/molecules/Product/ProductPrice.vue').default})
